export type Nullable<T> = T | null;

export enum RoutePath {
    LOGIN = "login",
    USERS = "users",
    DEVICES = "devices",
    ORDERS = "orders",
    TERMINATIONS = "terminations",
    SHIPMENTS = "shipments",
    ORGANIZATIONS = "organizations",
    COMPANYCARDS = "companyCards",
    EETS_DEVICES = "eetsDevices",
    FIRMWARES = "firmwares",
    PASSWORD = "password",
    SETTINGS = "settings",
    ASSETS = "assets",
}
